import { Box, IconButton, styled } from '@mui/material';

interface CameraWebcamBoundsProps {
  heightDefault?: boolean;
}

export const WebcamBounds = styled(Box, {
  shouldForwardProp: prop => prop != 'heightDefault',
})<CameraWebcamBoundsProps>(({ heightDefault }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  height: heightDefault ? 'auto' : 'calc(100vh - 64px)',
  textAlign: 'left',
}));

export const WebcamControls = styled(Box)(({ theme }) => ({
  position: 'absolute',
  marginTop: '10px',
  marginRight: '10px',
  top: 0,
  right: 0,
  display: 'flex',
  flexDirection: 'row',
  background: 'rgba(0, 0, 0, .5)',
  color: theme.colors.white,
  padding: 0, //theme.layout.spacing.small,
  borderRadius: '4px',
  zIndex: theme.layers.top,
  '& span:first-of-type': {
    padding: '22px 8px',
    cursor: 'move',
  },
}));

export const CameraIcon = styled(IconButton)`
  padding: 0;
  margin: 8px;
  width: 46px;
  height: 46px;
  background-color: rgba(255, 255, 255, 0.5);

  &:hover {
    background-color: rgba(255, 255, 255, 0.7);
  }

  & svg {
    width: 42px;
    height: 42px;
  }
`;
